export default {"src":"/_next/static/image/public/images/flags/flag_264.b36d06d2805c50415eb022a76aa4da59.svg","height":16,"width":24};